import React from "react"

import { CustomFeatureCatalog } from "../../../api/generated/QuadriConfigurationApi"
import AppContext from "../../../components/AppContext"
import Table from "../../../components/Table"

interface PublishedVersionsProps {
  history: any
  customFeatureCatalogs: CustomFeatureCatalog[]
}

class PublishedVersions extends React.Component<PublishedVersionsProps> {
  public static contextType = AppContext

  constructor(props: PublishedVersionsProps) {
    super(props)
  }

  public render() {
    // const history = useHistory()

    const rowData = this.props.customFeatureCatalogs.map((cfc, index) => {
      return {
        version: cfc.version,
        text: cfc.displayText,
        id: cfc.id
      }
    })

    const columnData = [
      {
        Header: "",
        accessor: "version",
        width: 70,
        style: { textAlign: "center" }
      },
      {
        Header: "Published Versions",
        accessor: "text"
      }
    ]

    const onRowClick = async (index: any) => {
      if (index !== -1) {
        const id = rowData.at(index)!.id!
        ;(this.props.history as any).push(`/featurecatalogdetails/${id}`)
        this.context.setPanelContent(null)
      }
    }

    return (
      <React.Fragment>
        <Table data={rowData} columns={columnData} disabled={false} onRowClick={onRowClick} />
      </React.Fragment>
    )
  }
}

export default PublishedVersions
